module.exports = __webpack_public_path__ + "static/media/Singapore.352bfddc.png";